var React = require('react');

function CvPastExperience (props) {
    return React.createElement("svg",props,React.createElement("circle",{"className":"fill-none stroke-border","strokeWidth":"2.5","cx":"24","cy":"24","r":"8.9"}));
}

CvPastExperience.defaultProps = {"version":"1.0","className":"experience__icon","width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = CvPastExperience;

CvPastExperience.default = CvPastExperience;
